import domReady from '@wordpress/dom-ready';

/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(robinkencelVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(robinkencelVars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
let screenSize = window.innerWidth;
document.documentElement.style.setProperty('--screen-size', `${screenSize}`);
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
 screenSize = window.innerWidth;
 document.documentElement.style.setProperty('--screen-size', `${screenSize}`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    window.isMobile = ( windowWidth <= mobileBreakpoint );
    window.isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Slick Options */
  import { prevArrow, nextArrow } from './util';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

domReady(() => {
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  /* Generic */
  if ( $('a.smooth-scroller, .smooth-scroller a').length ) { // internal links, smooth scrolling
    $('a.smooth-scroller, .smooth-scroller a').on('click', function(e){
      e.preventDefault();
      const target = $(this).attr('href');
      if ( target.charAt(0) === '#' && $(target).length > 0 ) {
        gsap.to(window, {
          scrollTo: {
            y: target,
            offsetY: 100
          },
          duration: 0.8,
          ease: 'power1.inOut'
        });
      }
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header').length ) {
    const header = $('.site-header');
    ScrollTrigger.create({
        trigger: 'body',
        start: 'top top-=15',
        end: 'bottom top',
        onEnter: () => {
          header.addClass('scrolled');
        },
        onLeaveBack: () => {
          header.removeClass('scrolled');
        }
    });
  }

  if ( $('.site-header__nav').length ) {
    const navResizeAction = (updated, navUpdated) => {
      if ( navUpdated ) {
        if ( isMobileNavigationActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
        }
      }
    };

    navResizeAction(true, true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated, navUpdated) => {
          if ( navUpdated ) {
            if ( isMobileNavigationActive ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('click', function(){
          if ( isMobileNavigationActive ) {
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavigationActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavigationActive ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  $('ul, ol').each(function(){
    if ( this.getAttribute('reversed') !== null ) {
      const items = $(this).children('li');
      $(this).css('counter-reset', 'olcounter ' + (items.length + 1));
    }

    if ( this.getAttribute('start') !== null ) {
      const start = parseInt(this.getAttribute('start'));
      $(this).css('counter-reset', 'olcounter ' + (start - 1));
    }
  });
  
  if ( $('.wp-block-video').length ) {
    $('.wp-block-video').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const minimalControls = ['play'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? minimalControls : controls ) : ($(el).is('video') ? minimalControls : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false ),
        iconUrl: robinkencelVars.svgSpritesheet,
      };
      
      window.localStorage.removeItem("plyr")
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        iconUrl: robinkencelVars.svgSpritesheet,
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  // dropdowns
  if ( $('.robinkencel-dropdown').length ) {
    $('.robinkencel-dropdown').each(function(){
      const container = this;
      const trigger = this.querySelector('.robinkencel-dropdown__toggle');
      const inner = this.querySelector('.robinkencel-dropdown__inner');
      const selectedText = trigger.querySelector('span');
      const optionsList = this.querySelector('.robinkencel-dropdown__dropdown');  
      const options = this.querySelectorAll('.robinkencel-dropdown__dropdown li');
      const hiddenField = this.querySelector('.robinkencel-dropdown__hidden-input');
      const labelEx = options;

      let isExpanded = false;

      $(optionsList).css({
        width: 'auto'
      });

      console.log(  Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px' );
      
      $(inner).css({
        'width': Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px'
      });
      
      $(optionsList).css({
        width: '100%'
      });

      /**
        Event handlers
      */
      const handleTriggerKeypresses = function (e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();
            
            if(isExpanded) {
              selectPreviousOption();
            } else {
              expandOptions();
            }
            
            break;
            
          case 'ArrowDown':
            e.preventDefault();
            
            if(isExpanded) {
              selectNextOption();
            } else {
              expandOptions();
              selectFirstOption();
            }
            
            break;
            
          case 'Home':
            if(isExpanded) {
              selectFirstOption();
            }
            
            break;
            
          case 'End':
            if(isExpanded) {
              selectLastOption();
            }
            
            break;
            
          case 'Tab':
            collapseOptions();
            break;
            
          case 'Escape':
          case 'Enter':
            if(isExpanded) {
              e.preventDefault();
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            }
            
            break;
        }
      }

      const handleBodyClick = function (e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      const handleTriggerClick = function () {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
        Show/hide option list
      */
      const collapseOptions = function () {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      const expandOptions = function () {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
        Option selection
      */
      const selectFirstOption = function () {
        var firstOption = options[0];
        selectOption(firstOption);
      }

      const selectLastOption = function () {
        var lastOption = options[options.length-1];
        selectOption(lastOption);
      }

      const selectNextOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            selectOption(nextOption);
          }
        }
      }

      const selectPreviousOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            selectOption(previousOption);
          }
        }
      }

      const selectOption = function (option) {
        unselectAllOptions();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
        
        // Scroll item into view
        
        
        // Update the hidden field
        hiddenField.value = $(option).data('value');
        $(hiddenField).trigger('change');
      }

      const unselectAllOptions = function () {  
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }

      // Handle keyboard and mouse interactions on the trigger bar
      trigger.addEventListener('keydown', handleTriggerKeypresses);
      trigger.addEventListener('click', handleTriggerClick);
      
      // Select options when they are clicked
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          unselectAllOptions();
          selectOption(e.target);
          collapseOptions();
          trigger.focus();
        });
      });
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);
    });
  }
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions
